/**
 * @file コンポーネント：フル動画ページ症例データの言語プルダウン DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Select } from "~/src/components/uiparts/Select";

// スタイル読み込み
import { StyledContent, StyledContentIcon } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledContent title={localized["Label.SelectLanguage"]}>
            <StyledContentIcon>
                <i className="fas fa-language"></i>
            </StyledContentIcon>
            {props.listLanguage.length > 0 && (
                <Select
                    list={props.listLanguage}
                    onChange={(e) => props.fnChangeSelect(e)}
                    onColor="sub"
                    value={props.languageCodeOperation}
                />
            )}
        </StyledContent>
    );
};
